function wp_toggle_team() {

    jQuery('.trigger-team_memberModal').on('click', function() {
      jQuery('#team_memberModal').foundation('open');
    });

    jQuery('.team .team_member').click(function(e){
        e.preventDefault();
        
        jQuery('.team .team_member').removeClass('active');
        jQuery(this).addClass('active');
        
        // Get selected
        var link_clicked = jQuery(this).clone().attr('team-to-open');
        // Hide all descriptions and product image
        jQuery('#team_memberModal .team-content .row.white').each(function() {
            jQuery(this).addClass('hide');
        });
        

        // Show relevant
        jQuery('#team_memberModal .team-content .row.white[data-member='+link_clicked+']').removeClass('hide');


    });


    

    jQuery('#team_memberModal .close-button').click(function(e){

        jQuery('.team .team_member').removeClass('active');

    });

}
